/**
 * Stable DOM-hook ids for the RecoveryAI sandbox spotlight controls.
 *
 * These `data-tour` values are baked onto the spotlight controls (A2) and read
 * by the AI-162 coach-mark tour so the markup and the tour share one source.
 * They are non-interactive DOM hooks (not user-visible text, not aria), so they
 * are intentionally NOT run through i18n.
 */
export const TOUR_ANCHORS = {
  // Legacy in-tab sandbox anchor (ScenarioDetailPanel) — retained for the
  // non-wizard shells that still render the detail panel.
  scenarioDetail: 'scenario-detail',
  chatInput: 'chat-input',
  decisionLog: 'decision-log',
  sandboxPrompt: 'sandbox-prompt',
  playbackNav: 'playback-nav',
  // AI-162 redesign anchors (wizard phone-mockup layout + two coach tours):
  simulator: 'simulator', // the phone device frame
  agentSettings: 'agent-settings', // the read-only Agent settings summary
  scenarioHeader: 'scenario-header', // the "Scenario n of 3 : …" heading
  reasoning: 'reasoning', // the AI reasoning panel
  continueButton: 'continue-button', // the wizard Continue nav button
} as const

export type TourAnchorKey = keyof typeof TOUR_ANCHORS

export const tourAnchorValue = (
  key: TourAnchorKey
): typeof TOUR_ANCHORS[TourAnchorKey] => TOUR_ANCHORS[key]

// Freeze at runtime so the shared anchor map cannot be mutated by a consumer.
Object.freeze(TOUR_ANCHORS)
